module.exports = __webpack_public_path__ + "media/images/vip-table-bookings-0f4be238b24aac3de4b28caf7b744b19.jpg";